import { render } from "./Regulation.vue?vue&type=template&id=a5bbeace&ts=true&lang=pug"
import script from "./Regulation.vue?vue&type=script&lang=ts"
export * from "./Regulation.vue?vue&type=script&lang=ts"

import "./Regulation.vue?vue&type=style&index=0&id=a5bbeace&lang=stylus"

import exportComponent from "/builds/CarrefourOneAPP/website/game/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__